import { type ContextData } from '@common/defaults/ContextData';
import { getThemeConfigByContext, type ThemeConfig, useThemeConfig } from '@common/hooks/useThemeConfig';

export interface NewsBlockListItemThemeConfig {
    showItemTag: boolean;
    showMeta: boolean;
    titleRowLimit: 2 | 3;
}

const THEME_CONFIG: ThemeConfig<NewsBlockListItemThemeConfig> = {
    defaults: {
        showItemTag: false,
        showMeta: true,
        titleRowLimit: 2,
    },
    byPlatform: {
        vi: {
            showItemTag: true,
            showMeta: false,
            titleRowLimit: 3,
        },
    },
};

export const getNewsBlockListItemThemeConfig = (contextData: ContextData) =>
    getThemeConfigByContext({ config: THEME_CONFIG, contextData });

export const useNewsBlockListItemThemeConfig = () => useThemeConfig(THEME_CONFIG);
